import React from "react";

import SearchIcon from "../../imgs/search.svg";
import Button from "../Common/Button";

const SearchInput: React.FC<{ displayButton?: boolean }> = ({
  displayButton = true,
}) => {
  return (
    <div className="flex w-full gap-4">
      <div className="flex w-full gap-2 bg-white bg-opacity-5 px-5 py-3 rounded-lg">
        <img src={SearchIcon} alt="search" />
        <input
          className="outline-none w-full bg-transparent text-white placeholder:text-opacity-50 text-left"
          placeholder="USDC, USDT, DAI, ARGO, 0x..."
        />
      </div>
      {displayButton && <Button>Search</Button>}
    </div>
  );
};

export default SearchInput;
